export const removeKeys = (obj, substrings) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) =>
      !substrings.some(sub => key.includes(sub))
    )
  );
}